var _objectSpread = require("E:\\project\\lesterlyu.github.io\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread2");

var _require = require('./grammar/hooks'),
    FormulaParser = _require.FormulaParser;

var _require2 = require('./grammar/dependency/hooks'),
    DepParser = _require2.DepParser;

var SSF = require('./ssf/ssf');

var FormulaError = require('./formulas/error'); // const funs = new FormulaParser().supportedFunctions();
// console.log('Supported:', funs.join(', '),
//     `\nTotal: ${funs.length}/477, ${funs.length/477*100}% implemented.`);


Object.assign(FormulaParser, _objectSpread({
  MAX_ROW: 1048576,
  MAX_COLUMN: 16384,
  SSF: SSF,
  DepParser: DepParser,
  FormulaError: FormulaError
}, require('./formulas/helpers')));
module.exports = FormulaParser;